import client from "./axiosConfig";

export const getVendorsGoodsNote = (params) =>{
    const config = {
        url: `/inventory/vendor-goods-notes/`,
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const createVendorsGoodsNote = (data) => {
    const config = {
        url: `/inventory/vendor-goods-notes/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const getVendorsGoodsNoteById = (id) => {
    const config = {
        url: `/inventory/vendor-goods-notes/${id}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
};

export const updateVendorsGoodsNote = (id, data) => {
    const config = {
        url: `/inventory/vendor-goods-notes/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const deleteVendorsGoodsNote = (id) => {
    const config = {
        url: `/inventory/vendor-goods-notes/${id}/`,
        method: "DELETE",
    };
    const response = client(config);
    return response;
};

export const getVGNMaterials = (vgn_id, params) => {
    const config = {
        url: `/inventory/vendor-goods-notes/${vgn_id}/materials/`,
        method: "GET",
        params, 
    };
    const response = client(config);
    return response;
}

export const addVGNMaterials = (vgn_id, data) => {
    const config = {
        url: `/inventory/vendor-goods-notes/${vgn_id}/materials/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const deleteVGNPhoto = (vgn_id) => {
    const config = {
        url: `/inventory/vendor-goods-notes/${vgn_id}/delete-material-photo/`,
        method: "DELETE",
    };
    const response = client(config);
    return response;
}; 